import { render, staticRenderFns } from "./VolumeByCustomerReport.vue?vue&type=template&id=05fb27d8&"
import script from "./VolumeByCustomerReport.vue?vue&type=script&lang=js&"
export * from "./VolumeByCustomerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports